import styled from 'styled-components'
import { mq } from '../../styles/vars/media-queries.style'

export const ContainedWrapMain = styled.div`
  display: block;

  ${props => (
    props.center
      ? `margin: 0 auto;`
      : ``
  )}
  ${mq.contained} {
    max-width: ${props => (props.size / 10)}rem;
  }

`
